<template>
  <v-simple-table fixed-header :dense="user.preferences.denseTables" class="entidades-table mt-4">
    <template v-slot:default>
      <thead>
        <tr>
          <td>
            <v-avatar color="primary" size="30" class="mr-1">
              <span class="white--text">{{ entidades.number.ticker }}</span>
            </v-avatar>
            Entidad emisora
          </td>
          <td class="text-right">
            <v-avatar color="primary" size="30" class="mr-1">
              <span class="white--text">
                {{ entidades.number.transmision }}
              </span>
            </v-avatar>
            Valor transmisión
            <InfoIcon
              :size="15"
              :text="`Suma de todos los totales recibidos con comisión, para todas las ventas realizadas en esta posición durante el año fiscal`"
            />
          </td>
          <td class="text-right">
            <v-avatar color="primary" size="30" class="mr-1">
              <span class="white--text">
                {{ entidades.number.adquisicion }}
              </span>
            </v-avatar>
            Valor adquisición
            <InfoIcon
              :size="15"
              :text="`Suma de todos los costes con comisión, para todas las ventas realizadas en esta posición durante el año fiscal`"
            />
          </td>
          <td class="text-right">
            <v-avatar color="primary" size="30" class="mr-1">
              <span class="white--text">{{ entidades.number.destinationRetention }}</span>
            </v-avatar>
            Retención realizada
            <InfoIcon
              :size="15"
              :text="`Suma de las retenciones ya realizadas en destino para esta posición durante el año fiscal`"
            />
          </td>
          <td class="text-right">
            <v-avatar color="secondary" size="30" class="mr-1">
              <span class="white--text">{{ entidades.number.profit }}</span>
            </v-avatar>
            Ganancia
            <InfoIcon
              :size="15"
              :text="`Ganancia en caso de que los valores de transmisión sean mayores a los valores de adquisición para esta posición`"
            />
          </td>
          <td class="text-right">
            <v-avatar color="secondary" size="30" class="mr-1">
              <span class="white--text">{{ entidades.number.loss }}</span>
            </v-avatar>
            Pérdida
            <InfoIcon
              :size="15"
              :text="`Pérdida en caso de que los valores de transmisión sean menores a los valores de adquisición para esta posición`"
            />
          </td>
        </tr>
      </thead>
      <tbody>
        <template v-if="entidades.data.entidades.length">
          <tr
            v-for="entidad in entidades.data.entidades"
            :key="entidad.ticker"
            :class="{
              'row-advise': entidad.someIncompleteExchangeRate,
            }"
          >
            <td class="items-flex">
              <TableTicker :type="positionType" :position="entidad" notLinkToDetail />
              <template v-if="entidad.someIncompleteExchangeRate">
                <div class="ml-3">
                  <WarningIcon :text="$t(`views.tax.fondosAcciones.warning.${positionType}`)" />
                </div>
              </template>
            </td>
            <td class="text-right">
              <currency :value="entidad.transmision" :currency="user.baseCurrency" />
            </td>
            <td class="text-right">
              <currency
                :value="entidad.adquisicion"
                :currency="user.baseCurrency"
                :hideDataNoPlanUser="hideDataNoPlanUser"
              />
            </td>
            <td class="text-right">
              <currency
                v-if="entidad.destinationRetention"
                :value="entidad.destinationRetention"
                :currency="user.baseCurrency"
              />
              <span v-else></span>
            </td>
            <td class="text-right">
              <currency
                v-if="entidad.profit"
                :value="entidad.profit"
                :currency="user.baseCurrency"
                text-green
                :hideDataNoPlanUser="hideDataNoPlanUser"
              />
              <span v-else></span>
            </td>
            <td class="text-right">
              <currency
                v-if="entidad.loss"
                :value="entidad.loss"
                :currency="user.baseCurrency"
                text-red
                negative
                :hideDataNoPlanUser="hideDataNoPlanUser"
              />
              <span v-else></span>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr class="v-data-table__empty-wrapper">
            <td :colspan="5">
              No hay ventas para este tipo de posición durante el año fiscal seleccionado
            </td>
          </tr>
        </template>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { mapState } from 'vuex'
import Currency from '@/views/components/common/Currency'
import WarningIcon from '@/views/components/common/WarningIcon'
import InfoIcon from '@/views/components/common/InfoIcon'
import TableTicker from '@/views/components/common/TableTicker'

export default {
  components: {
    Currency,
    WarningIcon,
    InfoIcon,
    TableTicker,
  },
  props: {
    positionType: {
      type: String,
      required: true,
    },
    entidades: {
      type: Object,
      default: () => {},
    },
    hideDataNoPlanUser: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['user']),
  },
}
</script>

<style lang="scss">
.entidades-table {
  tbody:before {
    //Separate from thead
    line-height: 1em;
    content: '\200C';
    display: block;
  }
}
</style>
